import * as preact from "preact";

import * as languageMap from "shared/languageMap";

export interface Props {
  items: string[];
  addButtonText: string;
  language: string;
  preventEmptyList?: boolean;
  autoFocus?: boolean;
  onChange: (items: string[]) => void;
}

class EditableListView extends preact.Component<Props> {
  firstInputElement: HTMLInputElement | null = null;
  lastInputElement: HTMLInputElement | null = null;

  render() {
    const rtl = languageMap.map[this.props.language].direction === "RTL";

    return (
      <ul class="editableListView">
        {this.props.items.map((item, index) => (
          <li>
            <input
              autoFocus={this.props.autoFocus && index === 0}
              value={item}
              onInput={(event) =>
                this.props.onChange([
                  ...this.props.items.slice(0, index),
                  event.currentTarget.value,
                  ...this.props.items.slice(index + 1),
                ])
              }
              lang={this.props.language}
              autoCapitalize="off"
              style={{
                ...(rtl
                  ? {
                      direction: "rtl",
                    }
                  : {}),
              }}
              ref={(input) => {
                if (index === 0) {
                  this.firstInputElement = input;
                }
                if (index === this.props.items.length - 1) {
                  this.lastInputElement = input;
                }
              }}
            />
            {this.props.preventEmptyList &&
            this.props.items.length === 1 ? null : (
              <button
                class="removeButton"
                onClick={() =>
                  this.props.onChange([
                    ...this.props.items.slice(0, index),
                    ...this.props.items.slice(index + 1),
                  ])
                }
              >
                <i class="icon icon-remove-sign"></i>
              </button>
            )}
          </li>
        ))}
        <li>
          <button
            onClick={() => {
              this.props.onChange([...this.props.items, ""]);
            }}
          >
            <i class="icon icon-plus"></i> {this.props.addButtonText}
          </button>
        </li>
      </ul>
    );
  }

  componentDidUpdate(previousProps: Readonly<Props>): void {
    if (
      previousProps.items.length < this.props.items.length &&
      this.lastInputElement
    ) {
      this.lastInputElement.focus();
    }
  }

  componentDidMount(): void {
    if (this.props.autoFocus && this.firstInputElement) {
      this.firstInputElement.focus();
    }
  }
}

export default EditableListView;
